import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventGroupCodeBannerBookableHotelQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type EventGroupCodeBannerBookableHotelQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    shouldShowEventGroupCode?: boolean | null;
    travelSettings?: { __typename?: 'TravelSettings'; showEventGroupCodeBanner?: boolean | null } | null;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      type?: Types.AccommodationPlaceType | null;
      isCustomLinkEnabled?: boolean | null;
      isFromAccommodationCatalog: boolean;
      accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock'; status: Types.AccommodationPlaceRoomBlockStatus; isJoyManagedRoomBlock: boolean } | null;
    }>;
  } | null;
};

export const EventGroupCodeBannerBookableHotelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventGroupCodeBannerBookableHotel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shouldShowEventGroupCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'showEventGroupCodeBanner' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accommodationRoomBlock' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventGroupCodeBannerBookableHotelQuery__
 *
 * To run a query within a React component, call `useEventGroupCodeBannerBookableHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventGroupCodeBannerBookableHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventGroupCodeBannerBookableHotelQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventGroupCodeBannerBookableHotelQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<EventGroupCodeBannerBookableHotelQuery, EventGroupCodeBannerBookableHotelQueryVariables>,
) {
  return ApolloReactHooks.useQuery<EventGroupCodeBannerBookableHotelQuery, EventGroupCodeBannerBookableHotelQueryVariables>(EventGroupCodeBannerBookableHotelDocument, baseOptions);
}
export function useEventGroupCodeBannerBookableHotelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventGroupCodeBannerBookableHotelQuery, EventGroupCodeBannerBookableHotelQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<EventGroupCodeBannerBookableHotelQuery, EventGroupCodeBannerBookableHotelQueryVariables>(
    EventGroupCodeBannerBookableHotelDocument,
    baseOptions,
  );
}
export type EventGroupCodeBannerBookableHotelQueryHookResult = ReturnType<typeof useEventGroupCodeBannerBookableHotelQuery>;
export type EventGroupCodeBannerBookableHotelLazyQueryHookResult = ReturnType<typeof useEventGroupCodeBannerBookableHotelLazyQuery>;
export type EventGroupCodeBannerBookableHotelQueryResult = Apollo.QueryResult<EventGroupCodeBannerBookableHotelQuery, EventGroupCodeBannerBookableHotelQueryVariables>;
